export default __webpack_public_path__ + "static/media/molten.4b8e2ea6.jpg";